export default {
    getUsersRights: () => {
        return {
            url: '/users_rights',
            method: 'GET'
        };
    },
    editUser: user => {
        return {
            url: '/users_rights/edit',
            method: 'PATCH',
            post_params: {
                id: user._id,
                email: user.email,
                lastname: user.lastname,
                firstname: user.firstname,
                active: user.active,
                user_rights: JSON.stringify(user.user_rights)
            }
        };
    },
    addUser: user => {
        return {
            url: '/users_rights/add',
            method: 'POST',
            post_params: {
                email: user.email,
                lastname: user.lastname,
                firstname: user.firstname,
                active: user.active,
                user_rights: JSON.stringify(user.user_rights)
            }
        };
    }
};



// WEBPACK FOOTER //
// ./scenes/UsersRights/api.js